import React, { useState, useEffect } from "react";
import {
  Col,
  Container,
  Row,
  Button,
  Modal,
  Form

} from "react-bootstrap";
import { InlineLoader, TableSkeletonRows } from "../loader";
import { TablePagination } from "../common/TablePagination";
import { EmptyTableState } from "../common/EmptyTableState";
import { StyledTable, StyledTableHeader, StyledTableCell, StyledTableRow } from "../common/StyledTable";
import swal from "sweetalert";
import { aiService } from "../../service/api.service";
import moment from "moment";
import 'bootstrap/dist/css/bootstrap.min.css';

export const AllLead = () => {
  const [userData, setUserData] = useState([]);
  const [totalItems, setTotalItems] = useState();
  const [listLoading, setListLoading] = useState(false);
  const [actionLoadingId, setActionLoadingId] = useState(null);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1)

  const [type, setType] = useState("")
  const [deactivatedReason, setDeactivatedReason] = useState("")
  const [reasonError, setReasonError] = useState("")

  const [calldata, setcallData] = useState()
  const [limit, setlimit] = useState(10)

  // const [userId, setUserId] = useState("")



  const [show, setShow] = useState(false);

  const handleClose = () => { setShow(false);  };
 

 
  useEffect(() => {
    lead_list(page, search)
  }, [page, search])

  async function lead_list(page, search) {
    setListLoading(true)
    try {
      const params = {
        page: page,
        search: search,
        limit:limit
       }
      const response = await aiService.leads(params)
      if (response?.status == 200) {
        let responseData = response.data.data
         setUserData(responseData)
        setTotalItems(response?.data?.total_count)
        console.log("?????????????list", response)
      }
    } catch (error) {
      if (error?.response?.status == 401) {
        swal({ icon: 'error', text: "Unauthorized", button: "OK" }).then(() => {
          localStorage.clear()
          window.location.href = "/";
          console.log('OK button clicked after error alert');
        });
      } else {
        swal({ icon: 'error', text: error?.response?.data?.message ? error?.response?.data?.message : error?.message, button: "OK" }).then(
          (value) => {
            console.log('OK button clicked after error alert');
          }
        );
      }
    } finally {
      setListLoading(false)
    }

  }

  function handlePageChange(pageNumber) {
    console.log("??????page", pageNumber)
    setPage(pageNumber);
    lead_list(pageNumber, search)
  }

  function handleUpdateSearch(search) {
    setSearch(search);
    setPage(1);
    lead_list(page, search)
  }




  async function makeCall(number,id,type) {
    setActionLoadingId(id)
    try {
      let params = {
        "lead_id":id,
        "phone":number,
        "company_type":type
      }
    const response = await aiService.makeCall(params)
      if (response.status == 200) {
        swal("Success", response?.data?.message, "success").then(() => {
          lead_list(page, search)
          setShow(false)
          setDeactivatedReason("")
          setReasonError("")

        })
     }
    } catch (error) {
      if (error?.response?.status == 401) {
        swal({ text: "Unauthorized", button: "OK" }).then(() => {
          localStorage.clear()
          window.location.href = "/";
        })
      } else {
      }
    } finally {
      setActionLoadingId(null)
    }
  }

  async function callList(id) {
    setActionLoadingId(id)
    try {
       const response = await aiService.callList(id)
      if (response.status == 200) {
        console.log(response)
        setcallData(response.data)
        setShow(true)

      }
    } catch (error) {
      if (error?.response?.status == 401) {
        swal({ text: "Unauthorized", button: "OK" }).then(() => {
          localStorage.clear()
          window.location.href = "/";
        })
      } else {
      }
    } finally {
      setActionLoadingId(null)
    }
  }
  function disableUser() {
    if (deactivatedReason !== "") {
      console.log("??????????????saveeeebutton click", deactivatedReason)
      // userStatus(userId)
      setReasonError("")
      setShow(false)
    } else {
      setReasonError("Please enter the reason")

    }
  }

 

  return (
    <>
      <div className="dashboard-main-area company-list-area">
        <Container fluid>
          <div className="dashboard-area-heading management-heading">
            <div className="under-content-section">
              <div>
                <h1 className="company-page-title">Leads</h1>
                <h5 className="company-page-subtitle">
                  {userData.length} of {totalItems || 0} leads
                </h5>
              </div>
              <div className="header-actions-right">
                <div className="search-top-right">
                  <Form.Control
                    placeholder="Search by name, email or phone…"
                    value={search}
                    onChange={(e) => handleUpdateSearch(e.target.value)}
                    onKeyDown={(e) => {
                      if (!e.target.value && e.code === "Space") {
                        e.preventDefault();
                      }
                    }}
                  />
                  <i className="fa fa-search" aria-hidden="true"></i>
                </div>
              </div>
            </div>
            <Row className="pb-4 justify-content-center">
              <Col md={12}>
                <div className="audit-request-box premium-company-card">
                  <StyledTable responsive="sm" className="UserListTable premium-user-list-table">
                    <thead>
                      <StyledTableRow>
                        <StyledTableHeader>Sr. No.</StyledTableHeader>
                        {/* <th>Image</th> */}
                        <StyledTableHeader>First Name</StyledTableHeader>
                        {/* <th>Last Name</th> */}
                        <StyledTableHeader className="email-section">Email</StyledTableHeader>
                        <StyledTableHeader>Phone</StyledTableHeader>
                        {/* <th>Source</th> */}
                        <StyledTableHeader>Action</StyledTableHeader>
                        <StyledTableHeader>Key Note</StyledTableHeader>
                        {/* <th>Action</th> */}
                      </StyledTableRow>
                    </thead>
                    <tbody>
                      {listLoading ? (
                        <TableSkeletonRows rows={limit} columns={6} />
                      ) : userData && userData?.length > 0 ? (
                        userData.map((data, index) => {
                          return (
                            <StyledTableRow key={index}>
                              <StyledTableCell>{(page - 1) * 10 + (index + 1)}</StyledTableCell>
                              {/* <td>{data?.image ? <img src={apiBaseUrl + data?.image} alt="image" height={50} width={50} className="rounded-circle" /> : <img src={userImg} alt="image" height={50} width={50} className="rounded-circle" />} </td> */}
                              <StyledTableCell>{data?.name ? <>{data?.name}</> : <>-</>}</StyledTableCell>
                              {/* <td>{data?.last_name ? <>{data?.last_name}{" "}{data?.last_name}</> : <>-</>}</td> */}
                              <StyledTableCell className="email-section">{data?.email ? <>{data?.email}</> : <>-</>}</StyledTableCell>
                              <StyledTableCell>{data?.phone_number ? <>{data?.phone_number}</> : <>-</>}</StyledTableCell>
                              <StyledTableCell>
                                <Button
                                  onClick={() => makeCall(data?.phone_number, data._id, data.company_type)}
                                  className="btn btn-success"
                                  disabled={actionLoadingId === data._id}
                                >
                                  {actionLoadingId === data._id ? <InlineLoader /> : "Call"}
                                </Button>
                              </StyledTableCell>
                              <StyledTableCell>
                                {data.keynotes?
                                <Button className="btn btn-success" onClick={() => callList(data._id)} disabled={actionLoadingId === data._id}>
                                  {actionLoadingId === data._id ? <InlineLoader /> : "View Keynote"}
                                </Button>
                              :"-"}
                             </StyledTableCell> 
                            </StyledTableRow>
                          )
                        })) : (
                        <EmptyTableState colSpan={10} />
                      )}
                    </tbody>
                  </StyledTable>
               
                  <TablePagination
                    activePage={page}
                    itemsCountPerPage={limit}
                    totalItemsCount={totalItems}
                    onChange={handlePageChange}
                  />
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </>
  );
};
